var url = 'https://api.lever.co/v0/postings/anovaculinary?mode=json';

// Checking for potential Lever source or origin parameters
var pageUrl = window.location.href;
var leverParameter = '';
var trackingPrefix = '?lever-';

if (pageUrl.indexOf(trackingPrefix) >= 0) {
  // Found Lever parameter
  var pageUrlSplit = pageUrl.split(trackingPrefix);
  leverParameter = '?lever-' + pageUrlSplit[1];
}

function createJobs(_data) {
  for (let i = 0; i < _data.length; i++) {
    var posting = _data[i];
    var title = posting.text;
    var location = posting.categories.location;
    var team = posting.categories.team;
    var link = posting.hostedUrl + leverParameter;

    $('#leverContainer .lever-list').append(
      '<div class="lever-list--listing">' +
        '<div class="lever-list--title-container">' +
        '<h2 class="lever-list--title">' +
        title +
        ', ' +
        team +
        '</h2>' +
        '<p class="lever-list--location">' +
        location +
        '</p>' +
        '</div>' +
        '<div class="lever-list--button-container">' +
        '<a target="_blank" class="button button--primary" href="' +
        link +
        '" title="Apply for the ' +
        title +
        ' role at Anova">Apply</a>' +
        '<div>' +
        '<div>'
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Fetching job postings from Lever's postings API
  $.ajax({
    dataType: 'json',
    url: url,
    error: function () {
      $('#leverButton').removeClass('hidden');
    },
    success: function (data) {
      if (data.length == 0) {
        $('#leverButton').removeClass('hidden');
      } else {
        createJobs(data);
      }
    },
  });
});
